import React, { useState } from 'react'
import { Box, Button, Icon } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

export interface TextSensitiveProps {
  text: string
  textClassName?: string
  containerClassName?: string
  visibleStartChars?: number
  visibleEndChars?: number
  ellipsisSymbol?: string
}
export const TextSensitive = ({
  text,
  containerClassName,
  textClassName,
  visibleStartChars = 10,
  visibleEndChars = 10,
  ellipsisSymbol = '.',
}: TextSensitiveProps) => {
  const [isTextEllipses, setIsTextEllipses] = useState(true)
  const ellipsesText = ellipseMiddleText(text, visibleStartChars, visibleEndChars, ellipsisSymbol)

  return (
    <Box flex justify="between" align="start" gap={8} className={containerClassName}>
      <Box className={textClassName}>{isTextEllipses ? ellipsesText : text}</Box>
      <Button
        variant="ghost"
        noPadding
        onClick={() => setIsTextEllipses(!isTextEllipses)}
        iconElement={<Icon name={isTextEllipses ? 'Eye' : 'EyeSlash'} />}
      />
    </Box>
  )
}
